import { createTheme, ThemeProvider } from '@mui/material';
import { useWindowWidth } from '@react-hook/window-size';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import Head from 'next/head';
// import Image from 'next/image';
import React, {useEffect, useMemo, useState} from 'react';
import { InView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { ReviewItem } from '../components/Lists/ReviewItem';
import { RecommendationItem } from '../components/RecommendationsList/RecommendationItem/RecommendationItem';
import { withLayout } from '../Layout/Layout';
import '../styles/utils.module.scss';
import { httpGet } from '../utils/httpClient';
import styles from './index.module.scss';
import { DestinationItem, SearchBox, VintageButton } from '../components';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// import LinearProgress from '@mui/material/LinearProgress';
// import Box from '@mui/material/Box'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
// import CreditCardOffOutlinedIcon from '@mui/icons-material/CreditCardOffOutlined';
// import TrustpilotLogo from '../public/images/logos/trustpilot.svg';
import { checkUserCountry } from '../utils/checkUserCountry';
import { OffersViews } from '../components/OffersViews/OffersViews';
// import { COUNTRIES } from '../config';
import { isCountryHasOffers } from '../utils/remoteAPI/offer';
import { OfferDetails } from '../components/OfferDetails/OfferDeatails';
import Image from 'next/image';
// import TrustPilotStars from '../public/images/logos/trustpilot-stars.svg'
// const News = dynamic(() => import('../components/News/News'));
const CallToSignUp = dynamic(() => import('../components/CallToSignUp/CallToSignUp'), {
  loading: () => <div>Loading Sign Up...</div>
});

const FeaturedContent = dynamic(() => import('../components/FeaturedContent/FeaturedContent'), {
  loading: () => <div>Loading Featured Content...</div>
});

// const DealsPage = dynamic(() => import('../components/DealsPage/Dealspage'), {
//   loading: () => <Box sx={{ width: '100%', backgroundColor: 'black' }}>
//   <LinearProgress color="secondary" />
// </Box>
// });

const getProfile = async () => {
  try {
    const res = await httpGet(`/api/user/profile`);
    return await res.json();
  } catch (e) {
    console.log(e);
  }
  return null;
}
const theme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#0a0a0a',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
  },
});

export const getStaticProps = async ({ locale }) => {
  const [featuredRes, destinationsRes] = await Promise.all([
    httpGet(`${process.env.javaApiUrl}/article?location=featured`),
    httpGet(`${process.env.javaApiUrl}/article?location=destination&size=3`)
  ]);

  if (featuredRes.status >= 400 || destinationsRes.status >= 400) {
    return {
      props: {},
      revalidate: 60,
    };
  }
  const featured = await featuredRes.json();
  const destinations = await destinationsRes.json();
  return {
    props: {
      featured,
      destinations,
      ...(await serverSideTranslations(locale, ['common'])),
    },
    revalidate: 60,
  };
};

const getFeaturedItems = async (paging) => {
  const response = await httpGet(
    `/api/article?location=featured&page=${paging.page}&size=${paging.pageSize}`
  );
  return await response.json();
};
const getVideo = async () => {
  const videoRes = await httpGet(`/api/video`);

  return await videoRes.json();
};

const getVideoMobile = async () => {
  const videoRes = await httpGet(`/api/video/mobile`);

  return await videoRes.json();
};
// const getFeaturedFlights = async (country, origin) => {
//   const featuredFlightsDealsRes = await httpGet(
//     `/api/flight/deals?origin=${origin}&country=${country}&cabinClass=BIZ&size=6`
//   );

//   return await featuredFlightsDealsRes.json();
// };
// const getFeaturedOrigins = async (country) => {
//   const featuredFlightsDealsRes = await httpGet(
//     `/api/flight/popular/origin?country=${country}&cabinClass=BIZ`
//   );

//   return await featuredFlightsDealsRes.json();
// };

const getReviews = async () => {
  const [airlineReviewRes, hotelReviewRes, destinationsListRes] = await Promise.all([
    httpGet(`/api/airline/review?size=1&sort=random`),
    httpGet(`/api/hotel?size=1&sort=random`),
    httpGet(`/api/destinations?size=1&sort=random`),
  ]);

  const airlineReview = await airlineReviewRes.json();
  const hotelReview = await hotelReviewRes.json();
  const destinationsList = await destinationsListRes.json();
  return {
    airlineReview: airlineReview.content[0],
    hotelReview: hotelReview.content[0],
    destinationsList: destinationsList.content[0],
  };
};

const getOfferById = async (offerid) => {
  const offerRes = await httpGet(`/api/offer/items/${offerid}`);

  if (offerRes.status >= 400) {
    return null;
  }

  return await offerRes.json();
}

// Main page
// - Offer&Deal
//    example: http://localhost:4200?country=US&origin=NYC&destination=MLE&cabinClass=BIZ&currency=USD&date=2025-07-05&rdate=2025-07-12
// - SkyScanner:
//      - url includes utm_source=skyscanner
//      - prefill origin,destination,dates,persons
//    Example: origin=SYD&destination=LON&from-date=2025-09-10&to-date=2025-09-20&occupancy=2&utm_medium=cpc&utm_source=skyscanner&utm_campaign=standardunpriced

function Home({ featured, destinations, authCompleted }) {
  const { t } = useTranslation();
  const router = useRouter();
  const userStore = useSelector((state) => state.user.value);
  // const [windowWidth, setWindowWidth] = useState(0);
  const [video, setVideo] = useState(null);
  // const [cookieAccepted, setCookieAccepted] = useState(false);
  const [searchBoxTab, setSearchBoxTab] = useState(0);
  const [isVideo, setIsVideo] = useState(false);
  const [airlineReview, setAirlineReview] = useState(null);
  const [destinationsList, setDestinationsList] = useState(null);
  const [hotelReview, setHotelReview] = useState(null);
  const [inspiration, setInspiration] = useState(featured.content);
  const [inspirationInfiniteLoop, setInspirationInfiniteLoop] = useState(false);
  const [inspirationPaging, setInspirationPaging] = useState({
    total: featured.totalElements,
    pageSize: featured.pageable.pageSize,
    page: featured.pageable.pageNumber,
  });
  const [isVideoFetched, setIsVideoFetched] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [defaultOrigin, setDefaultOrigin] = useState(null);
  const [openedOffer, setOpenedOffer] = useState(null);
  const [advLinkSearchData, setAdvLinkSearchData] = useState(null);
  const width = useWindowWidth();
  const isMobile = width < 1024;

  const offerViewsDefaultOrigin = useMemo(() => (
    advLinkSearchData ? {
      origin: advLinkSearchData.origin,
    } : {
      origin: userStore?.country === userStore?.detectCountry ? defaultOrigin : null,
      country: userStore?.country
    }
  ), [userStore?.country, userStore?.detectCountry, defaultOrigin, advLinkSearchData]);

  useEffect(() => {
    if (!userStore || !userStore.country) return;

    // const withScroll = width + 17;
    // setWindowWidth(withScroll);
    // if (checkUserCountry(userStore?.country, userStore?.detectRegion)) {
    //   setVideo({image: '/images/night-sky.webp'});
    //   setIsVideo(false);
    //   setIsVideoFetched(false);
    //   return;
    // }

    // setVideo(null);

    if (!isVideoFetched || !video) {
      const fetchVideo = width < 1024 ? getVideoMobile : getVideo;
      
      fetchVideo().then((vid) => {
        setVideo(vid);
        if (vid?.image.includes('.mp4')) {
          setIsVideo(true);
        }
        setIsVideoFetched(true);
      });
    }

  }, [userStore?.country]);

  useEffect(() => {
    const updateOrigin = (origin) => {
      setDefaultOrigin(origin || (userStore?.country !== userStore?.detectCountry ? userStore?.country : userStore?.detectRegion));
    };

    if (userStore?.country) {
      isCountryHasOffers(userStore?.country).then((hasOffers) => {
        if (!hasOffers) {
          setDefaultOrigin(null);
        } else {
          if (userStore?.userid) {
            getProfile().then((profile) => {
              setProfileData(profile);
              updateOrigin(profile?.userAirports?.[0]?.code);
            });
          } else {
            const preferredAirport = localStorage.getItem('BC_preferredAirport');
            updateOrigin(preferredAirport ? JSON.parse(preferredAirport)?.code : null);
          }
        }
      });
    }
  }, [userStore?.userid, userStore?.country]);

  useEffect(() => {
    // let cookieState = JSON.parse(localStorage.getItem('bcCookieConsentShowed'));
    // if (cookieState) {
    //   setCookieAccepted(cookieState);
    // } else {
    //   window.addEventListener('storage', () => {
    //     cookieState = JSON.parse(localStorage.getItem('bcCookieConsentShowed'));
    //     if (cookieState) {
    //       setCookieAccepted(cookieState);
    //     }
    //   });
    // }

    getReviews().then((res) => {
      const { airlineReview, hotelReview, destinationsList } = res;
      setAirlineReview(airlineReview);
      setHotelReview(hotelReview);
      setDestinationsList(destinationsList);
    });
  }, []);
  useEffect(() => {
    if (!router.query) return;

    if (router.query['hotelsearch']) {
      setSearchBoxTab(1);
    }

    if (router.query['offerid']) {
      if (JSON.parse(sessionStorage.getItem('BC-offerIDOpened')) !== null) {
        return;
      }
      getOfferById(router.query['offerid']).then((offer) => {
        if (offer) {
          setOpenedOffer(offer);
        }
      });
    }

    if (router.query['utm_source'] === 'skyscanner') {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const origin = params.get('origin');
      const destination = params.get('destination');
      const from = params.get('from-date');
      const to = params.get('to-date');
      const passengers = +params.get('occupancy');
      if (origin && destination && from) {
        setAdvLinkSearchData({
          origin,
          destination,
          from,
          to,
          passengers
        });
      }
    }
  }, [router]);

  // useEffect(() => {
  //   if (!cookieAccepted) return;
    
  //   const script = document.createElement('script');
  //   script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5728937966944779";
  //   script.async = true;
  //   script.crossOrigin = "anonymous";
  //   document.body.appendChild(script);
  
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, [cookieAccepted]);

  useEffect(() => {
    if (inspirationPaging.page <= 3) {
      getFeaturedItems(inspirationPaging)
        .then((res) => {
          if (inspiration[0].title !== res.content[0].title) {
            setInspiration([...inspiration, ...res.content]);
          } else {
            setInspiration([...res.content]);
          }
          if (inspirationPaging.page === 2) {
            setInspirationInfiniteLoop(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [inspirationPaging]);

  return (
    <ThemeProvider theme={theme}>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}`} />
        {/* {cookieAccepted && (
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5728937966944779"
            crossOrigin="anonymous"
          ></script>
        )} */}
        <meta name="verify-admitad" content="7c7aa268bd" />
      </Head>
      <div className={cn(styles.topSection, checkUserCountry(userStore?.country, userStore?.detectRegion) && styles.topSectionPattern)}>
        {video && video.image && isVideo && (
          <>
            <video
              className={cn(styles.topBackground, 'vjs-tech')}
              src={process.env.mediaUrl + video.image.replace('/', '')}
              autoPlay
              muted
              loop
              playsInline
            />
            <div className={cn(styles.topSectionText, 'font-fragment')}>
              {t('index.topSection')}
            </div>
          </>
        )}

        {video && video.image && !isVideo && (
          <>
            {width > 1024 && (
              <Image
                // src={process.env.mediaUrl + video.image.replace('/', '')}
                src={process.env.mediaUrl + video.image?.replace('/', '')}
                className={cn(styles.topBackground, 'vjs-tech')}
                alt="Top image"
                layout={'fill'}
                objectFit={'cover'}
                objectPosition={'top center'}
              />          
            )}
            {/* <Image
              className={cn(styles.topBackground, 'vjs-tech')}
              src={process.env.mediaUrl + video.image.replace('/', '')}
              alt="Top image"
              layout={'fill'}
              objectFit={'cover'}
              objectPosition={'top center'}
            /> */}
            <div className={cn(styles.topSectionText, 'font-fragment', profileData && 'text-3xl')}>
              {profileData?.firstName ? `Hi ${profileData?.firstName}! ` : ''}
              {t('index.topSection')}
              {/* {defaultOrigin && (
                <>  
                  {' '} from {' '}
                  <b>
                    {defaultOrigin ? ` ${profileData?.userAirports[0]?.name.split(',')[0].trim()}` : ''}
                  </b>
                </>
              )} */}
            </div>
          </>
        )}

        <div className={cn(styles.topSectionSearch, 'container mx-auto')}>
          <SearchBox
            type={width && width < 1024 ? 'sideSearch' : 'mainSearch'}
            activeTab={searchBoxTab}
            flightSearchValue={advLinkSearchData ? {
              from: advLinkSearchData.origin,
              to: advLinkSearchData.destination,
              cabinClass: 'BIZ',
              dateRange: {
                departure: advLinkSearchData.from,
                return: advLinkSearchData.to,
              },
              passengers: {
                adults: advLinkSearchData.passengers,
              },
              tripState: 'round_trip',
            } : undefined}
            // flightSearchValue={{
            //   from: null,
            //   to: null,
            //   cabinClass: 'BIZ',
            //   dateRange: {
            //     departure: null,
            //     return: null,
            //   },
            //   passengers: {
            //     adults: 1,
            //   },
            //   tripState: 'round_trip',
            // }}
            searchSource={'Main search'}
            hotelSearchValue={{}}
          />
        </div>

        <div className={cn(styles.trustSection, 'container mx-auto')}>
          <div className={styles.trustSectionContainer}>
            <Carousel
              responsive={{
                mobile: {
                  breakpoint: { max: 1024, min: 0 },
                  items: 1,
                },
                desktop: {
                  breakpoint: { min: 1025, max: 5000 },
                  items: 3,
                },
              }}
              arrows={false}
              infinite={true}
              draggable={isMobile}
              showDots={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              autoPlay={isMobile}
              swipeable={isMobile}
              containerClass={styles.carouselContainer}
              itemClass={styles.carouselItem}
              ssr={true}
              shouldResetAutoplay={true}
            >

               {/* Column 1 */}
               <div className={styles.trustItem}>
                <div className={styles.trustUsers}>
                  {/* <TrustPilotStars height={30}/> */}
                  {/* <img src="/images/logos/trustpilot-stars.svg" alt="Trustpilot Rating" height={30}/> */}
                  <img src="/images/logos-mini/deal.png" height={40} width={35} alt='Trust by users icon'/>
                </div>
                <div className={cn(styles.text)}>
                  {/* <h3 className='font-libre'>Trusted by Travellers {profileData ? `from ${COUNTRIES[profileData.countryResidence]}` : ' Worldwide'}</h3> */}

                  <h3 className='font-libre'>Trusted by 5 million users</h3>
                  {/* <p className='flex w-full items-center justify-center'>4.7/5 Rating <TrustpilotLogo className='ml-2 max-h-5' /> </p> */}
                  <p>Since 2021</p>
                </div>
              </div>
              {/* Column 2 */}
              <div className={styles.trustItem}>
                <div className={styles.logos}>
                  <img src="/images/logos-mini/kayak.png" alt="Kayak" height={30}/>
                  <img src="/images/logos-mini/expedia-small.png" alt="Expedia" height={30} />
                  <img src="/images/logos-mini/booking.png" alt="Booking.com" height={30} />
                  <img src="/images/logos-mini/hotels-small.png" alt="Hotels.com" height={30} />
                </div>
                <div className={styles.text}>
                  <h3 className='font-libre'>Compare & Save</h3>
                  <p>Search, compare & book top fares from 100s of sites</p>
                </div>
              </div>

              {/* Column 3 */}
              <div className={styles.trustItem}>
                <div className={styles.icon}>
                  {/* <CreditCardOffOutlinedIcon /> */}
                  <img src="/images/logos-mini/free-outline.png" height={40} width={35} alt='Free to use icon'/>
                </div>
                <div className={styles.text}>
                  <h3 className='font-libre'>Completely Free to Use</h3>
                  <p>No fees, no hidden charges — simply great deals</p>
                </div>
              </div>
            </Carousel>
          </div>
        </div>

        {/* {!checkUserCountry(userStore?.country) && userStore && !userStore.userid && (
          <InView triggerOnce>
            {({ inView, ref }) => (
              <div
                ref={ref}
                className={cn(
                  styles.callToSignUpContainer,
                  'w-full mx-auto relative'
                )}
              >
                {inView && (
                  <CallToSignUp
                    country={userStore?.country}
                    authCompleted={authCompleted}
                    isCutomBackground={true}
                    sourcePage={'Index page top'}
                  />
                )}
              </div>
            )}
          </InView>
        )} */}
      </div>

      {/* {!checkUserCountry(userStore?.country, userStore?.detectRegion) && defaultOrigin && (
        <OffersViews defaultOrigin={{
          origin: userStore?.country === userStore?.detectCountry ? defaultOrigin : null,
          country: userStore?.country
        }}
        ></OffersViews>
      )} */}

      {defaultOrigin && (
        <OffersViews defaultOrigin={offerViewsDefaultOrigin}
                     defaultDestination={advLinkSearchData ? {
                       destination: advLinkSearchData.destination,
                     } : undefined}
                     backupOrigin={{
                       origin: 'All origins',
                       country: userStore?.country,
                     }}
          // setDealsLoginDialogState={setDealsLoginDialogState}
        ></OffersViews>
      )}

      <InView triggerOnce>
        {({ inView, ref }) => (
          <div ref={ref} className={cn(styles.featuredContentWrapper)}>
            <div className={cn(styles.featuredContent)}>
              <div className="container">
                <div className={'px-4 lg:px-0'}>
                  {inView && (
                    <FeaturedContent
                      items={inspiration}
                      enableInfinite={inspirationInfiniteLoop}
                      executePaginate={() =>
                        setInspirationPaging({
                          ...inspirationPaging,
                          page: inspirationPaging.page + 1,
                        })
                      }
                    />
                  )}
                </div>

                <div className={'w-1/2 lg:w-1/4 mx-auto mt-6'}>
                  <VintageButton
                    href="/hotels/toplists"
                    label={t('index.moreFinestSelection')}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </InView>

      <InView triggerOnce>
        {({ inView, ref }) => (
          <div ref={ref} className={cn(styles.content, 'container')}>
            {inView && (
              <div className="container flex flex-col lg:flex-row justify-center lg:mt-6 sm:mt-3 gap-4">
                <div
                  className={cn(
                    styles.recommendationsList,
                    'flex flex-col w-full lg:w-1/2 mr-4 order-2 lg:order-1'
                  )}
                >
                  <div className={styles.sameHeigtContainer}>
                    {destinationsList && <DestinationItem item={destinationsList} />}
                    <div className="flex justify-center items-center mt-6 mb-10">
                      <div className={'w-1/2 mx-auto'}>
                        <VintageButton
                          dark={true}
                          href="/destinations?tab=destinations"
                          label={t('index.moreDestinations')}
                        />
                      </div>
                    </div>
                  </div>

                  {destinations.content.map((destination, index) => {
                    if (width && width < 1024 && index >= 1) {
                      return;
                    }
                    return (
                      <RecommendationItem
                        key={destination.title}
                        item={destination}
                      />
                    );
                  })}
                  <div className="flex justify-center items-center my-6">
                    <div className={'w-1/2 mx-auto'}>
                      <VintageButton
                        dark={true}
                        href="/destinations?tab=articles"
                        label={t('index.moreGuides')}
                      />
                    </div>
                  </div>
                </div>
                <div className="order-1 lg:order-2 flex flex-col w-full lg:w-1/2 mt-8 lg:mt-0 lg:ml-4">
                  <div className={styles.sameHeightContainer}>
                    <div className={styles.review}>
                      {airlineReview && (
                        <ReviewItem
                          type="Airline"
                          review={airlineReview}
                          url={`/airlines/reviews/${airlineReview.textId}`}
                        />
                      )}
                    </div>
                    <div className="flex justify-center items-center mt-6 mb-10">
                      <div className={'w-1/2 mx-auto'}>
                        <VintageButton
                          dark={true}
                          href="/airlines/reviews"
                          label={t('index.moreAirlineReviews')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles.review}>
                    {hotelReview && (
                      <ReviewItem
                        type="Hotel"
                        starRating={true}
                        review={hotelReview}
                        url={`/hotel/review/${hotelReview.textId}`}
                      />
                    )}
                  </div>
                  <div className="flex justify-center items-center my-6">
                    <div className={'w-1/2 mx-auto'}>
                      <VintageButton
                        dark={true}
                        href="/hotels/reviews"
                        label={t('index.moreHotelReviews')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </InView>

      {userStore && !userStore.userid && (
        <InView triggerOnce>
          {({ inView, ref }) => (
            <div ref={ref} className="w-full mx-auto">
              {inView && (
                <CallToSignUp
                  country={userStore?.country}
                  authCompleted={authCompleted}
                  sourcePage={'Index page bottom'}
                />
              )}
            </div>
          )}
        </InView>
      )}
      {/* <InView triggerOnce>
        {({ inView, ref }) => (
          <div className={'bg-brown-background w-full pb-10'} ref={ref}>
            <div className="container">{inView && <News />}</div>
          </div>
        )}
      </InView> */}

      {openedOffer && openedOffer?.id && (
        <OfferDetails isOpen={true}
          data={openedOffer}
          searchSource={'Main page link'}
          closeDetails={() => {
            setOpenedOffer(null);
            sessionStorage.setItem('BC-offerIDOpened', null);
          }}>
        </OfferDetails>
      )}
    </ThemeProvider>
  );
};

export default withLayout(Home, true, false);
